import { useCallback } from 'react';

import { useStoreContext } from 'features/store';
import { pick } from 'lodash-es';

import usePosVendor from 'hooks/menu/use-pos-vendor';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { NonNullableReward } from 'pages/loyalty/loyalty-rewards/types';
import { useMenuQueryOptions } from 'state/unified-menu/use-menu-query-options';
import logger from 'utils/logger';

import { LoyaltyOffer } from '../types';

type TLoggerFunction = (
  params:
    | {
        loyaltyItem: LoyaltyOffer;
        loyaltyItemType: 'Offer';
      }
    | {
        loyaltyItem: NonNullableReward;
        loyaltyItemType: 'Reward';
      }
) => void;

export const useLoyaltyUnavailableLogger = (hookName: string) => {
  const { store } = useStoreContext();
  const { vendor } = usePosVendor();
  const { posServiceMode } = useMenuQueryOptions();
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();

  return useCallback<TLoggerFunction>(
    ({ loyaltyItem, loyaltyItemType }) => {
      logger.info({
        message: `[${hookName}]: Unavailable ${loyaltyItemType.toLowerCase()}. ${loyaltyItemType} Id: ${
          loyaltyItem._id
        }`,
        [loyaltyItemType.toLowerCase()]: {
          ...pick(loyaltyItem, ['_id', '__typename', 'loyaltyEngineId']),
        },
        store: { ...pick(store, ['_id', 'number']), isUnifiedMenuEnabled, vendor },
        serviceMode: posServiceMode,
      });
    },
    [hookName, isUnifiedMenuEnabled, posServiceMode, store, vendor]
  );
};
